<template>
  <!-- 对话框 -->
  <el-drawer title="协助指派" :visible.sync="show" :before-close="closeDialog" size="80%" @opened="openDrawer"
    class="order-detial-wrap" :show-close="false">

    <div class="box">


      <div id="container_transfer" style="display: flex; justify-content: center; align-items: center;"></div>



      <!-- 推荐服务人员 -->
      <div class="driver-box">
        <div class="right-top">

          <h4 class="title">推荐服务人员</h4>

          <div class="right-top-search-btn-group">
            <el-button style="padding: 4px 8px;" :type="actual ?'primary':''" @click="actualBtn">
              实际距离
            </el-button>
            <el-button style="padding: 4px 8px;" :type="right_top_search_btn == 'distance'?'primary':''"
              @click="rightTopSearchBtn('distance')">
              距离
              <i class="el-icon-top"></i>
            </el-button>
            <el-button style="padding: 4px 8px;" :type="right_top_search_btn == 'points'?'primary':''"
              @click="rightTopSearchBtn('points')">
              分数
              <i class="el-icon-top"></i>
            </el-button>

          </div>

          <i class='el-icon-refresh' style="font-size: 20px;cursor: pointer;float: right;font-weight: 800;"
            @click="searchDriver(search_driver_data.lng,search_driver_data.lat,slider_km)"></i>

          <div class="block">
            <span class="demonstration fs14-w500">搜索半径({{slider_km}}公里)</span>
            <el-slider v-model="slider" :step="5" :min="5" show-stops @change="sliderChange" :show-tooltip="false"
              style="padding-left: 10px;">
            </el-slider>
          </div>


          <div class="block">
            <span class="demonstration fs14-w500">搜索人数({{search_driver_num}}人)</span>
            <el-slider v-model="slider_driver" class="slider-driver" :step="5" show-stops @change="sliderDriverChange"
              :show-tooltip="false" style="padding-left: 10px;">
            </el-slider>
          </div>




          <div class="block">
            <span class="demonstration fs14-w500">
              AI距离({{matching.slider_km_ai}}公里)
            </span>
            <el-slider v-model="matching.slider_ai" :step="5" :min="5" show-stops style="padding-right: 10px;"
              @change="sliderAIChange" :show-tooltip="false">
            </el-slider>
          </div>
          <p style="padding-left: 25px;font-size: 12px;font-weight: 400; color: red;">*注：订单会在选定的AI距离内搜索司机进行匹配</p>

          <div class="block">
            <span class="demonstration fs14-w500">AI匹配人数(/单)({{matching.radius_slider_num}}人)</span>
            <el-slider v-model="matching.radius_slider_driver" class="slider-driver" :step="50" show-stops
              @change="matchingSliderDriverChange" :show-tooltip="false" style="padding-left: 10px;">
            </el-slider>
          </div>

          <p style="padding-left: 25px;font-size: 12px;font-weight: 400; color: red;">*注：每需要一名代驾员需要匹配多少名代驾员抢单</p>




          <el-table :data="rightToptableData" @selection-change="handleSelectionChange" ref="multipleTable"
            v-loading="loading" max-height="400">

            <el-table-column type="selection" width="45" align="center" prop="driver_code"></el-table-column>

            <el-table-column prop="real_name" label="姓名" width="120" fixed align="center">


              <template slot-scope="scope">

                <div style="display: flex;justify-content: start">

                  <!--司机段位图片-->
                  <img
                          style="width: 30px;height: 30px;margin-right: 5px;display: inline-block;"
                          :src="scope.row.dan == 0 ? require('@/assets/11.png'):(scope.row.dan == 1 ? require('@/assets/22.png'):(scope.row.dan == 2 ? require('@/assets/33.png'):require('@/assets/44.png')))"
                  >


                  <!--司机姓名-->
                  <span style="height: 32px;line-height: 32px;display: block">
                  {{ scope.row.real_name }}
                </span>


                </div>

              </template>



            </el-table-column>

            <el-table-column prop="Linear_distance" label="直线/实际" min-width="120" align="center">
              <template slot-scope="scope">
                {{ Math.floor(scope.row.Linear_distance/10)/100 }}km
                /
                {{ scope.row.distance == '--'? scope.row.distance : Math.floor(scope.row.distance/10)/100 }}km
              </template>
            </el-table-column>

            <el-table-column prop="duration" label="分数" min-width="80" align="center">
              <template slot-scope="scope">
                {{  scope.row.monitor_point }}
              </template>
            </el-table-column>



            <el-table-column prop="duration" label="骑行" min-width="50" align="center">
              <template slot-scope="scope">
                {{ scope.row.duration == '--'? scope.row.duration : Math.ceil(scope.row.duration/60) }}分
              </template>
            </el-table-column>


            <el-table-column prop="phone" label="电话" min-width="100" align="center">
            </el-table-column>



            <el-table-column label="今日完成" min-width="100">
              <template slot-scope="scope">
                ￥{{ scope.row.sum_num }}( {{ scope.row.count_num }}单)
              </template>
            </el-table-column>


            <el-table-column label="今日听单时长" min-width="120">
              <template slot-scope="scope">
                {{ Math.ceil(scope.row.today_online_time/60) }}分钟
              </template>
            </el-table-column>

          </el-table>

        </div>

        <div style="display: flex;margin-top: 50px;">
          <span style="font-size: 14px;margin-right: 10px;">备注:</span>
          <el-input type="textarea" v-model="submit_data.remarks" style="width: 300px;"></el-input>
        </div>




      </div>


    </div>

    <div style="display: flex;justify-content: center;height: 32px;margin: 20px 0;">
      <el-button @click="transferSubmit('no')" type="primary">确认</el-button>
      <el-button @click="closeDialog">返回</el-button>
      <el-button @click="transferSubmit('AI')" type="success">一键AI</el-button>
    </div>


  </el-drawer>
</template>

<script>
  var _this, map, contextMenu, contextMenuPositon, startMarker, endMarker, circle, driving, leagueMarker,polyline1, polyline2, polyline3;
  import bus from '../../../common/bus.js';
  export default {

    props: {
      'isShow': Boolean,
      'city': '',
      'transferOrder_start': '',
      'order_code': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;


        _this.city_name = _this.city;

        _this.search_driver_data = _this.transferOrder_start;

        _this.submit_data.order_code = _this.order_code;

        var data = {
          "server_status_0": 1,
          "server_status_1": 0,
          'server_status_2': 0,
          'server_status_3': 0,
          'server_status_4': 0,
          'server_status_5': 0,
          'server_status_6': 0,
          'switch': 1,
          'status': 1 // 1只返回听单中司机，2所有状态司机都返回
        }



        var sendData = {
          "ws_mode": 'driverControl',
          "driver_control_synchronization": JSON.stringify(data)
        }

        _this.global.ws.send(JSON.stringify(sendData));


      },
    },
    data() {
      return {


        show: false,

        city_name: '',

        driver: [],

        // AI派单匹配滑块
        matching: {
          radius_slider_driver: 100,
          radius_slider_num: 3,
          slider_km_ai: 3,
          slider_ai: 15
        },

        loading: false,

        // 滑块
        slider: 15,
        slider_km: 3,

        slider_driver: 50,
        search_driver_num: 10,

        // 实际距离按钮
        actual: false,

        search_driver_data: {
          lng: '',
          lat: ''
        },
        end: {
          lng: '',
          lat: ''
        },

        driverMarks_status: [],

        right_top_search_btn: localStorage.getItem('order_by') == null ? 'distance' : localStorage.getItem('order_by'),

        rightToptableData: [],

        // 表单数据
        submit_data: {
          order_code: '',
          driver_code_array: '',
          remarks: ''
        },


      };
    },
    created() {

      _this = this;

    },
    methods: {

      //AI派单匹配人数滑块
      matchingSliderDriverChange(val) {


        if (val == 0) {
          _this.matching.radius_slider_num = 1
        } else if (val == 50) {
          _this.matching.radius_slider_num = 2
        } else if (val == 100) {
          _this.matching.radius_slider_num = 3
        }

      },


      transferSubmit(val) {

        if (val == 'AI') {

          var sendData = {
            "ws_mode": 'adminHelpSend',
            'order_code': _this.submit_data.order_code,
            'driver_code_array': val == 'AI' ? '' : _this.submit_data.driver_code,
            'remarks': _this.submit_data.remarks,
            'ai_find_radius': _this.matching.slider_km_ai,
            'ai_num': _this.matching.radius_slider_num
          }

        } else {
          var sendData = {
            "ws_mode": 'adminHelpSend',
            'order_code': _this.submit_data.order_code,
            'driver_code_array': _this.submit_data.driver_code,
            'remarks': _this.submit_data.remarks,
            'ai_find_radius': '',
            'ai_num': ''
          }
        }



        console.log(sendData);


        // 发送数据
        _this.global.ws.send(JSON.stringify(sendData));

      },

      actualBtn() {

        _this.actual = !_this.actual;
        _this.searchDriver(_this.search_driver_data.lng, _this.search_driver_data.lat, _this.slider_km);



      },


      openDrawer() {

        // 地图初始化
        map = new AMap.Map('container_transfer', {
          resizeEnable: true, //是否监控地图容器尺寸变化
          zoom: 11, //初始地图级别
        });

        var limit_num = 10;
        if(localStorage.getItem('city_tag')=='KUNMING'){
          limit_num = 500
        }


        // 联盟商家坐标

        _this.$post(
          "/admin.php/Business/ipcShoppingLists", {
            page: 1,
            limit: limit_num,
            shop_name: '',
          }).then(res => {

          if (res.data.length > 0) {

            for (let i = 0; i < res.data.length; i++) {

              leagueMarker = new AMap.Marker({
                icon: new AMap.Icon({
                  image: require('@/assets/League.png'),
                  size: new AMap.Size(25, 34), //图标大小
                  imageSize: new AMap.Size(25, 34)
                }),
                position: [res.data[i].lng, res.data[i].lat],
                size: new AMap.Size(25, 34),
                offset: new AMap.Pixel(-13, -30)
              });
              leagueMarker.setMap(map);

            }

          }

        }).catch((err) => {

        })

        // 将地图绑定点击事件   点击关闭信息窗口
        map.on('click', this.closePop);

        // 使用地图工具(平移工具，测距工具)
        AMap.plugin(['AMap.RangingTool', 'AMap.CitySearch', 'AMap.Geocoder', 'AMap.Driving'], function () {

          map.addControl(new AMap.CitySearch())

        })

        map.on('rightclick', function (e) {
          contextMenu.open(map, e.lnglat);
          contextMenuPositon = e.lnglat;
        });


        // 创建起点坐标
        _this.startMark(Number(_this.search_driver_data.lng), Number(_this.search_driver_data.lat));

        //创建右键菜单
        var contextMenu = new AMap.ContextMenu();


        //右键添加起点
        contextMenu.addItem("创建起点", function () {



          // 添加起点标记
          _this.startMark(contextMenuPositon.lng, contextMenuPositon.lat);
          _this.startName(contextMenuPositon);

        }, 0);

        //右键添加终点
        contextMenu.addItem("创建终点", function () {

          // 添加终点标记
          _this.endMark(contextMenuPositon.lng, contextMenuPositon.lat);
          _this.endName(contextMenuPositon);

        }, 0);


        //右键添加清除所有坐标点
        contextMenu.addItem("清除所有坐标点", function () {

          // 清空地图上所有覆盖物
          _this.clearMap();

        }, 0);


        // 请求城市列表接口   获取围栏信息
        this.$post(
            "/admin.php/city/getCityDetails"
          )
          .then(res => {




            if (res.data.free_area_coordinate_array != null && res.data.free_area_coordinate_array != '[]') {

              var path1 = JSON.parse(res.data.free_area_coordinate_array);

              path1.push(JSON.parse(res.data.free_area_coordinate_array)[0]);

            }




            if (res.data.far_area_coordinate_array != null && res.data.far_area_coordinate_array != '[]') {

              var path2 = JSON.parse(res.data.far_area_coordinate_array);

              path2.push(JSON.parse(res.data.far_area_coordinate_array)[0]);

            }




            if (res.data.effective_area_coordinate_array != null && res.data.effective_area_coordinate_array != '[]') {

              var path3 = JSON.parse(res.data.effective_area_coordinate_array);

              path3.push(JSON.parse(res.data.effective_area_coordinate_array)[0]);

            }


            console.log(path1);
            // 创建小围栏(绿色)
            polyline1 = new AMap.Polyline({
              path: path1,
              isOutline: true,
              outlineColor: 'transparent',
              borderWeight: 3,
              strokeColor: "green",
              strokeOpacity: 0.5,
              strokeWeight: 6,
              // 折线样式还支持 'dashed'
              strokeStyle: "solid",
              // strokeStyle是dashed时有效
              strokeDasharray: [10, 5],
              lineJoin: 'round',
              lineCap: 'round',
              zIndex: 50,
            });

            polyline1.setMap(map);


            if (path2) {

              // 创建大围栏(粉色)
              polyline2 = new AMap.Polyline({
                path: path2,
                isOutline: true,
                outlineColor: 'transparent',
                borderWeight: 3,
                strokeColor: "#FF33FF",
                strokeOpacity: 0.5,
                strokeWeight: 6,
                // 折线样式还支持 'dashed'
                strokeStyle: "solid",
                // strokeStyle是dashed时有效
                strokeDasharray: [10, 5],
                lineJoin: 'round',
                lineCap: 'round',
                zIndex: 50,
              })

              polyline2.setMap(map);

            }


            if (path3) {

              // 创建大围栏(黑色)
              polyline3 = new AMap.Polyline({
                path: path3,
                isOutline: true,
                outlineColor: 'transparent',
                borderWeight: 3,
                strokeColor: "black",
                strokeOpacity: 0.5,
                strokeWeight: 6,
                // 折线样式还支持 'dashed'
                strokeStyle: "solid",
                // strokeStyle是dashed时有效
                strokeDasharray: [10, 5],
                lineJoin: 'round',
                lineCap: 'round',
                zIndex: 50,
              })
              polyline3.setMap(map);

            }



          }).catch((err) => {

          })

        // // 截取城市名称 如:吉林省 / 长春市 => 长春市
        // var city_name = _this.city_name.slice(_this.city_name.indexOf('/') + 2)




        // // 根据城市决定地图中心点
        // map.setCity(city_name, function (params) {

        // })

        map.setCenter([_this.search_driver_data.lng, _this.search_driver_data.lat])


        _this.global.ws.onmessage = function (res) {


          var resData = JSON.parse(res.data);

          _this.$driverState(resData);

          // console.log(resData);



          if (resData.identification == "driver_control" && resData.header == "success") {
            // 如果接收到司机数据

            // 如果是听单中状态的司机则添加司机标签，否则不处理
            if (resData.data.status == '1') {

              // 添加司机标签
              _this.addDriver(resData.data.driver_code, resData.data.real_name, resData.data.lng, resData.data.lat,
                resData.data.status, resData.data.dan);

            } else {

              if (typeof (_this.driver[resData.data.driver_code]) !== 'undefined') {

                // 清除对应的司机标签
                _this.driver[resData.data.driver_code].setMap(null);

                // 将对象中对应的driver_code对象删除
                delete _this.driver[resData.data.driver_code];

              }

            }

          }  else if (resData.header == "error") {
            // 接收到弹窗信息

            _this.$message.error(resData.msg)



          }else if (resData.identification == "driver_listen_cut" && resData.header == "success") {
            // 如果接收到司机cut数据

            if (typeof (_this.driver[resData.data.driver_code]) !== 'undefined') {

              // 清除对应的司机标签
              _this.driver[resData.data.driver_code].setMap(null);

              // 将对象中对应的driver_code对象删除
              delete _this.driver[resData.data.driver_code];

            }

          }else if (resData.identification == "driver_offline" && resData.header == "success") {
            // 如果接收到司机下线数据


            if (typeof (_this.driver[resData.data.driver_code]) !== 'undefined') {

              // 清除对应的司机标签
              _this.driver[resData.data.driver_code].setMap(null);

              // 将对象中对应的driver_code对象删除
              delete _this.driver[resData.data.driver_code];

            }

          } else if (resData.identification == "nearbyDriver" && resData.header == "success") {
            // 搜索司机的数据
            // console.log(resData);
            _this.rightToptableData = resData.data.result;
            _this.loading = false;

          } else if (resData.identification == "nearbyDriver" && resData.header == "fail") {
            // 搜索司机的数据
            // console.log(resData);
            _this.rightToptableData = [];
            _this.loading = false;

          } else if (resData.identification == "adminHelpSend" && resData.header == "success") {
            // 搜索转派成功的数据
            // console.log(resData);
            _this.$emit('tipModelShow', resData.msg);
            _this.$message.success(resData.msg);
            _this.closeDialog();
            _this.$emit('onSubmit')


          } else if (resData.identification == "adminHelpSend" && resData.header !== "success") {
            // 搜索转派失败的数据
            // console.log(resData);
            _this.$message.error(resData.msg);
          } else if (resData.identification == "link" && resData.header == "logout") {
            // 接收token失效

            // 关闭socket
            bus.$emit('firstlog', false);

          }

        }





      },

      // 创建起点点标记
      startMark(lng, lat) {

        if (startMarker) {
          map.remove(startMarker)
        }
        var lnglat = String(lng) + ',' + String(lat);
        _this.search_driver_data.lng = lng;
        _this.search_driver_data.lat = lat;
        _this.submit_data.start_coordinate = lnglat;
        // 添加起点标记
        // 创建一个 Icon
        var startIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(25, 34),
          // 图标的取图地址
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          // 图标所用图片大小
          imageSize: new AMap.Size(135, 40),
          // 图标取图偏移量
          imageOffset: new AMap.Pixel(-9, -3)
        });

        // 将 icon 传入 marker
        startMarker = new AMap.Marker({
          position: new AMap.LngLat(lng, lat),
          icon: startIcon,
          draggable: true,
          offset: new AMap.Pixel(-13, -30),
          zIndex: 999
        });

        map.add(startMarker);


        // 起点点标记拖动事件
        startMarker.on('dragend', function (params) {


          _this.search_driver_data.lng = startMarker.getPosition().lng;
          _this.search_driver_data.lat = startMarker.getPosition().lat;



          _this.circleInit();
          _this.searchDriver(_this.search_driver_data.lng, _this.search_driver_data.lat, _this.slider_km);




          var lnglat = String(startMarker.getPosition().lng) + ',' + String(startMarker.getPosition().lat)

          _this.submit_data.start_coordinate = lnglat

          _this.startName(lnglat)

        })

        _this.circleInit();
        _this.main_right_show = true;
        _this.searchDriver(lng, lat, _this.slider_km)
      },


      // 根据坐标获取起点名称
      startName(lnglat) {
        var geocoder = new AMap.Geocoder({
          city: _this.currentCity, //城市设为北京，默认：“全国”
          radius: 500 //范围，默认：500
        });
        geocoder.getAddress(lnglat, function (status, result) {



          if (result.regeocode.addressComponent.neighborhood == '') {

            if (result.regeocode.addressComponent.building == '') {

              var address = result.regeocode.formattedAddress;

            } else {
              var address = result.regeocode.addressComponent.building;
            }

          } else {

            var address = result.regeocode.addressComponent.neighborhood;

          }


          _this.submit_data.start_name = address;




          // 如果起点和终点都存在，则规划驾车导航
          if (_this.submit_data.start_name != '' && _this.submit_data.end_name != '') {



            // 规划驾车导航
            _this.drivingLine();

          }


        });
      },


      // 规划驾车路线
      drivingLine() {

        if (driving) {
          //调用clear()函数清除上一次结果，可以清除地图上绘制的路线以及路径文本结果
          driving.clear();
          _this.distance = '0';
          _this.estimate = '0';
        }


        //构造路线导航类
        driving = new AMap.Driving({
          map: map,
          hideMarkers: true
        });




        driving.search(new AMap.LngLat(Number(_this.search_driver_data.lng), Number(_this.search_driver_data.lat)),
          new AMap.LngLat(Number(_this.end.lng), Number(_this.end.lat)),
          function (status,
            result) {
            _this.distance = Math.round(result.routes[0].distance / 100) / 10;
            _this.estimate = Math.round(result.routes[0].time / 60);



            if (status === 'complete') {
              log.success('绘制驾车路线完成')
            } else {
              log.error('获取驾车数据失败：' + result)
            }
          });

      },


      // 根据坐标获取终点名称
      endName(lnglat) {
        var geocoder = new AMap.Geocoder({
          city: _this.currentCity, //城市设为北京，默认：“全国”
          radius: 500 //范围，默认：500
        });
        geocoder.getAddress(lnglat, function (status, result) {



          if (result.regeocode.addressComponent.neighborhood == '') {

            if (result.regeocode.addressComponent.building == '') {

              var address = result.regeocode.formattedAddress;

            } else {
              var address = result.regeocode.addressComponent.building;
            }

          } else {

            var address = result.regeocode.addressComponent.neighborhood;

          }



          _this.submit_data.end_name = address;

          // 如果起点和终点都存在，则规划驾车导航
          if (_this.submit_data.start_coordinate != '' && _this.submit_data.end_coordinate != '') {

            // 规划驾车导航
            _this.drivingLine();

          }

        });
      },


      // 创建终点点标记
      endMark(lng, lat) {
        if (endMarker) {
          map.remove(endMarker)
        }
        var lnglat = String(lng) + ',' + String(lat)
        _this.end.lng = lng;
        _this.end.lat = lat;
        _this.submit_data.end_coordinate = lnglat;
        // 添加终点标记
        // 创建一个 Icon
        var endIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(25, 34),
          // 图标的取图地址
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          imageSize: new AMap.Size(135, 40),
          imageOffset: new AMap.Pixel(-95, -3)
        });

        // 将 icon 传入 marker
        endMarker = new AMap.Marker({
          position: new AMap.LngLat(lng, lat),
          icon: endIcon,
          draggable: true,
          offset: new AMap.Pixel(-13, -30),
          zIndex: 999
        });

        map.add(endMarker);

        // 终点点标记拖动事件
        endMarker.on('dragend', function (params) {

          _this.end.lng = endMarker.getPosition().lng;
          _this.end.lat = endMarker.getPosition().lat;

          var lnglat = String(endMarker.getPosition().lng) + ',' + String(endMarker.getPosition().lat)



          _this.submit_data.end_coordinate = lnglat;

          _this.endName(lnglat)


        })
      },


      // 添加司机方法
      addDriver(driver_code, name, lng, lat, status, dan) {



        // 根据司机状态决定文本标签的背景色
        switch (status) {
          case '0':

            var backgroundColor = '#B9B9B9';

            break;
          case '1':

            var backgroundColor = '#61D59C';

            break;
          case '2':

            var backgroundColor = '#00A4DC';

            break;
          case '3':

            var backgroundColor = '#9296F0';

            break;
          case '4':

            var backgroundColor = '#BBC22C';

            break;
          case '5':

            var backgroundColor = '#FADC05';

            break;
          case '6':

            var backgroundColor = '#FAB105';

            break;
          case '7':

            var backgroundColor = '#FA6705';

            break;
          case '8':

            var backgroundColor = '#FA4705';

            break;

          default:
            break;
        }




        // 如果driver_code存在,不需要新添加司机标签
        if (typeof (_this.driver[driver_code]) !== 'undefined') {


          // 如果接收到的数据不存在坐标并且司机标签已经存在，则只改变颜色
          if (lng != undefined && lng != null && lng != '' && lat != undefined && lat != null && lat != '') {

            //更改司机标签的坐标
            _this.driver[driver_code].setPosition([lng, lat]);

          }




          // 如果信息窗口存在并且已经打开
          if (_this.driverMarks_status[driver_code] && _this.driverMarks_status[driver_code].getIsOpen()) {


            // 更改司机信息窗口的坐标
            _this.driverMarks_status[driver_code].setPosition([lng, lat]);

          }



          _this.driver[driver_code].setStyle({

            'background-color': backgroundColor

          })




          return;
        } else if (typeof (_this.driver[driver_code]) == 'undefined' && (lng == undefined || lng == null || lng ==
            '' || lat == undefined || lat == null || lat == '')) {
          //如果driver_code不存在而且也没有坐标点直接直接return

          return;

        }

        // 根据司机状态决定文本标签的背景色
        switch (String(dan)) {
          case '0':

            var driver_logo = require('@/assets/11.png');

            break;
          case '1':

            var driver_logo = require('@/assets/22.png');

            break;
          case '2':

            var driver_logo = require('@/assets/33.png');



            break;
          case '3':

            var driver_logo = require('@/assets/44.png');



            break;

          default:
            break;
        }

        // 创建纯文本标记（司机标签）
        _this.driver[driver_code] = new AMap.Text({
          text: '<div style="display:flex;"><img style="margin:0 auto;display:block;width:25px;height:25px;" src="' +
            driver_logo + '">' + name + '</div>',
          anchor: 'center', // 设置文本标记锚点
          draggable: true,
          cursor: 'pointer',
          animation: 'AMAP_ANIMATION_DROP',
          angle: 0,
          style: {
            'padding': '.5rem .5rem',
            'margin-bottom': '1rem',
            'border-radius': '.25rem',
            'background-color': backgroundColor,
            'width': '',
            'border-width': 0,
            'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
            'text-align': 'center',
            'font-size': '14px',
            'color': '#fff'
          },
          position: [lng, lat]
        });

        _this.driver[driver_code].setMap(map);

        // 1秒后清除点标掉落效果的动画(防止点标抖动)
        setTimeout(() => {
          if (_this.driver[driver_code]) {
            _this.driver[driver_code].setAnimation('AMAP_ANIMATION_NONE')
          }

        }, 1000);


        // 文本标记的点击事件
        var clickHandle = AMap.event.addListener(_this.driver[driver_code], 'click', function () {


          _this.$post(
            "/driver/getPerformance", {
              driver_code: driver_code
            }
          ).then(res => {


            if (res.data.logo_img.url == '' || res.data.logo_img.url == null) {

              _this.url = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

            } else {

              _this.url = res.data.logo_img.url;

            }



            // 创建信息窗口
            _this.driverMarks_status[driver_code] = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: '<div style="width:180px;background-color:white;padding: 20px;box-sizing: border-box;border-radius: 5px">' +
                '<div style="overflow: hidden; width:80px;height:80px;margin:0 auto;border-radius: 50%;">' +
                '<img style="margin:0 auto;display:block;width:100%;height:100%;" src="' + _this.url +
                '">' +
                '</div>' +
                '<h4 style="text-align: center;font-weight: bold;font-size: 18px">' + name + '</h4>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">今日完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.today_order_nums + '单</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">本月完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.month_order_nums + '单</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">任职状态</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.is_full_time + '</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">综合指数</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.exponent_driver_points_ + '分</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">司机电话</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.phone + '</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">定位时间</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.position_time.YmdHis + '</span> </p>' +
                '</div>',
              offset: new AMap.Pixel(0, -20)
            });

            //打开信息窗口
            _this.driverMarks_status[driver_code].open(map, _this.driver[driver_code]
              .getPosition()); //后面的参数指的是经纬度，在此显示窗口


          }).catch((err) => {

          })


        });



      },


      // 搜索司机数据顺序
      rightTopSearchBtn(val) {

        _this.right_top_search_btn = val;

        localStorage.setItem('order_by', val);


        _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km)

      },


      // 搜索司机
      searchDriver(lng, lat, radius) {
        _this.loading = true;
        if (localStorage.getItem('order_by') == null || localStorage.getItem('order_by') == undefined) {

          var order_by_data = 'distance';

        } else {

          var order_by_data = localStorage.getItem('order_by');

        }

        _this.rightToptableData = [];

        var searchDriverData = {
          'ws_mode': 'nearbyDriver',
          'lng': lng,
          'lat': lat,
          'search_radius': radius,
          'order_by': order_by_data,
          'num': String(_this.search_driver_num),
          'is_amap': _this.actual ? '1' : '0'
        }



        // console.log(searchDriverData);


        // 发送数据搜索司机
        _this.global.ws.send(JSON.stringify(searchDriverData));



      },
      sliderAIChange(val) {

        if (startMarker) {

          _this.matching.slider_km_ai = val / 5;
          _this.circleInit('AI');
          _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km)

        }

      },

      // 滑块数据改变时触发
      sliderChange(val) {


        if (startMarker) {

          _this.slider_km = val / 5;
          _this.circleInit('nomorl');
          _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km)

        }


      },


      sliderDriverChange(val) {

        _this.search_driver_num = val / 5;

        _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km);

      },


      // 地图圆形初始化
      circleInit(val) {
        if (circle) {
          map.remove(circle);
        }

        circle = new AMap.Circle({
          center: [startMarker.getPosition().lng, startMarker.getPosition().lat],
          radius: val == 'AI' ? _this.matching.slider_km_ai * 1000 : _this.slider_km * 1000, //半径
          borderWeight: 3,
          strokeColor: "transparent",
          strokeOpacity: 1,
          strokeWeight: 6,
          strokeOpacity: 0.2,
          fillOpacity: 0.2,
          strokeStyle: 'dashed',
          strokeDasharray: [10, 10],
          // 线样式还支持 'dashed'
          fillColor: '#1791fc',
          zIndex: 50,
          bubble: true // 将覆盖物的鼠标或touch等事件冒泡到地图上
        })
        circle.setMap(map);



      },

      // 选择司机触发
      handleSelectionChange(val) {


        var datalist = [];


        for (var i in val) {

          datalist.push(val[i].driver_code);

        }


        _this.submit_data.driver_number = datalist.length;

        // 如果选择司机超过了限定人数
        if (_this.submit_data.driver_number > _this.driver_number) {

          _this.submit_data.driver_number = 0;
          _this.$message.error('司机超过限定人数')
          // 清空选择
          _this.$refs.multipleTable.clearSelection();
          _this.submit_data.driver_code = '';

        }


        _this.submit_data.driver_code = JSON.stringify(datalist);
      },


      // 管理司机信息窗口方法
      closePop() {
        // 遍历关闭信息窗口
        for (const key in _this.driverMarks_status) {
          _this.driverMarks_status[key].close();
        }

      },

      // 清除地图方法
      clearMap() {

        // 清空路线规划
        if (driving) {
          //调用clear()函数清除上一次结果，可以清除地图上绘制的路线以及路径文本结果
          driving.clear();
          _this.distance = '0';
          _this.estimate = '0';
        }

        // 清除起点坐标
        if (startMarker) {
          map.remove(startMarker);
          _this.search_driver_data.lng = '';
          _this.search_driver_data.lat = '';
          _this.submit_data.start_coordinate = '';
          _this.submit_data.start_name = '';
        }

        if (circle) {
          map.remove(circle);
        }



        // 清除终点坐标
        if (endMarker) {
          map.remove(endMarker);
          _this.end.lng = '';
          _this.end.lat = '';
          _this.submit_data.end_coordinate = '';
          _this.submit_data.end_name = '';
        }

      },


      closeDialog() {

        _this.search_driver_data = {
          lng: '',
          lat: ''
        }
        _this.end = {
          lng: '',
          lat: ''
        }
        _this.driver = [];
        _this.driverMarks_status = [];
        _this.rightToptableData = [];
        _this.loading = false;
        _this.actual = false;

        _this.submit_data = {
          order_code: '',
          driver_code_array: '',
          remarks: ''
        }

        _this.show = false;


        // 关闭时通知App.vue链接Socket
        bus.$emit('appToSocket');

      },



    }
  };
</script>

<style scoped>
  /* 高德地图css */
  @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';
  @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/prety-json.css';

  #container_transfer {
    height: 100%;
    width: 50%;
  }

  .order-model {
    margin: 20px 0;
  }


  .mode-data {

    margin: 20px 0;
  }

  iframe {
    width: 100%;
    border: medium none;
    height: 100%;
  }

  h4 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }

  h5 {
    font-size: 20px;
    font-weight: normal;
  }

  .text-btn {
    font-size: 18px;
    margin-left: 20px;
    padding: 5px;
    display: block;
  }

  .box {
    height: calc(100vh - 200px);
    overflow: hidden;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
  }

  .box>div {
    margin: 20px 0;
  }

  .tag {
    padding: 5px;
    border-radius: 5px;
  }

  .tag {
    background-color: red;
  }

  .tag.active {
    background-color: green;
  }

  .driver-box {
    width: 50%;
    padding-left: 20px;
    box-sizing: border-box;
  }

  .right-top {
    width: 100%;
    overflow-y: auto;
    position: relative;
    max-height: 100%;
  }



  .right-top-search-btn-group {
    position: absolute;
    right: 10px;
    top: 5px;
  }

  .title {
    color: rgb(129, 129, 129);
    border-bottom: 1px solid #eee;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    text-indent: 10px;
    position: relative;
    font-weight: 500;
    color: #111213;
    text-align: left;
  }

  .el-slider {
    width: 65%;
    transform: translate(-5%, -10%);
  }

  .slider-driver {
    transform: translate(-8%, -10%);
  }

  .block {
    width: 95%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .block span {
    display: block;
    height: 30px;
    line-height: 30px;
  }
</style>